export default "__VITE_PUBLIC_ASSET__0ba3e44b__"